import type { CustomerServiceInfo } from '../../../api/customerService';

/**
 * 单个客服信息卡片：展示服务名称、电话、邮箱、工作时间、地址、
 * 微信二维码（有则显示）与简介。
 */
export default function CustomerServiceCard({ service }: { service: CustomerServiceInfo }) {
  return (
    <div className="bg-white rounded-xl border border-gray-100 p-5">
      <div className="flex items-start gap-3 mb-4">
        <div className="w-10 h-10 shrink-0 flex items-center justify-center bg-teal-50 rounded-full">
          <i className="ri-customer-service-2-line text-teal-500" />
        </div>
        <div className="min-w-0">
          <p className="text-sm font-medium text-gray-900">{service.serviceName}</p>
          {service.description && (
            <p className="text-xs text-gray-400 mt-0.5 line-clamp-2">{service.description}</p>
          )}
        </div>
      </div>

      <div className="space-y-2 text-xs text-gray-600">
        {service.phone && (
          <div className="flex items-center gap-2">
            <div className="w-4 h-4 flex items-center justify-center">
              <i className="ri-phone-line text-teal-400" />
            </div>
            <a href={`tel:${service.phone}`} className="hover:text-teal-600 transition-colors">
              {service.phone}
            </a>
          </div>
        )}
        {service.email && (
          <div className="flex items-center gap-2">
            <div className="w-4 h-4 flex items-center justify-center">
              <i className="ri-mail-line text-teal-400" />
            </div>
            <a href={`mailto:${service.email}`} className="hover:text-teal-600 transition-colors truncate">
              {service.email}
            </a>
          </div>
        )}
        {service.workingHours && (
          <div className="flex items-center gap-2">
            <div className="w-4 h-4 flex items-center justify-center">
              <i className="ri-time-line text-teal-400" />
            </div>
            <span>{service.workingHours}</span>
          </div>
        )}
        {service.address && (
          <div className="flex items-center gap-2">
            <div className="w-4 h-4 flex items-center justify-center">
              <i className="ri-map-pin-2-line text-teal-400" />
            </div>
            <span className="truncate">{service.address}</span>
          </div>
        )}
      </div>

      {service.wechatQrCodeUrl && (
        <div className="mt-4 pt-4 border-t border-gray-50 flex items-center gap-3">
          <img
            src={service.wechatQrCodeUrl}
            alt="微信二维码"
            className="w-20 h-20 rounded-lg border border-gray-100 object-cover"
          />
          <div>
            <p className="text-xs font-medium text-gray-700">微信联系</p>
            <p className="text-[11px] text-gray-400 mt-1">扫码添加客服微信</p>
          </div>
        </div>
      )}
    </div>
  );
}